var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{attrs:{"fluid":""}},[_c('ripa-page-container',{attrs:{"view-stops-with-errors":_vm.viewStopsWithErrors}},[_c('ripa-pwa-wrapper'),_c('router-view',{key:_vm.$route.fullPath,on:{"on-view-stops-with-errors":_vm.handleViewStopsWithErrors}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }